type LibraryPayloadMetadata = {
  members: unknown[]
  name: string
  namespace?: string
  version: string
  runtimeVersion?: string
}

const hasGraftModelType = (value: unknown): value is { unifiedGraftModelType?: unknown; graftModelType?: unknown } =>
  typeof value === 'object' &&
  value !== null &&
  (Object.hasOwn(value as object, 'unifiedGraftModelType') || Object.hasOwn(value as object, 'graftModelType'))

const normalizeRuntimeVersion = (value: unknown): string | undefined => {
  const text = String(value ?? '').trim()
  if (!text || text.toLowerCase() === 'unknown') return undefined
  return text
}

export const getLibraryPayloadMetadata = (payload: unknown[]): LibraryPayloadMetadata => {
  const firstMemberIndex = payload.findIndex(hasGraftModelType)
  const membersFrom = firstMemberIndex === -1 ? payload.length : firstMemberIndex

  if (membersFrom === 2 || membersFrom === 4) {
    return {
      name: String(payload[0] ?? ''),
      version: String(payload[1] ?? ''),
      runtimeVersion: membersFrom === 4 ? normalizeRuntimeVersion(payload[2]) : undefined,
      members: payload.slice(membersFrom),
    }
  }

  const namespace = String(payload[0] ?? '')
  return {
    namespace: namespace || undefined,
    name: String(payload[1] ?? payload[0] ?? ''),
    version: String(payload[2] ?? payload[1] ?? ''),
    runtimeVersion: membersFrom >= 5 ? normalizeRuntimeVersion(payload[3]) : undefined,
    members: payload.slice(membersFrom),
  }
}
